import script from "./ShapeStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapeStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./ShapeStylePanel.vue?vue&type=style&index=0&id=4668817c&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4668817c"]])

export default __exports__